import { Upload } from "lucide-react";

interface ProfileBannerProps {
  bannerUrl?: string | null;
  isOwnProfile: boolean;
  onUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ProfileBanner = ({ bannerUrl, isOwnProfile, onUpload }: ProfileBannerProps) => {
  return (
    <div className="h-48 rounded-xl bg-gradient-to-r from-flux-purple/20 to-flux-blue/20 relative group">
      {bannerUrl && (
        <img 
          src={bannerUrl} 
          alt="Profile banner"
          className="w-full h-full object-cover rounded-xl"
        />
      )}
      {isOwnProfile && (
        <label className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer">
          <input
            type="file"
            accept="image/*"
            onChange={onUpload}
            className="hidden"
          />
          <Upload className="w-6 h-6 text-white" />
        </label>
      )}
    </div>
  );
};